<template>
  <div>
    <h1>Ma super application illustrative</h1>
    <ProgressBar :progress="progress" />
  </div>
</template>

<script>
import ProgressBar from './components/ProgressBar';

export default {
  name: 'app',
  components: {
    ProgressBar
  },
  data: function() {
    return {
      progress: 0
    };
  },
  mounted: function() {
    const interval = setInterval(
      () => {
        this.progress += 5;
        (this.progress >= 100) && clearInterval(interval);
      },
      300
    );
  }
}
</script>

<style>

</style>
